var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "document-upload-step" }, [
    _c(
      "div",
      { staticClass: "document-upload-list mg mg--b-8" },
      _vm._l(_vm.documents, function (document) {
        return _c("ma-upload-document-item", {
          key: document.id,
          attrs: {
            name: document.name,
            id: document.id,
            canBeDeleted: document.canBeDeleted,
          },
          on: {
            onDeleteClick: _vm.handleDocumentDeleteClick,
            onDownloadClick: _vm.handleDocumentDownloadClick,
          },
        })
      }),
      1
    ),
    _c("input", {
      staticClass: "document-upload-input is-hidden",
      attrs: {
        accept: _vm.acceptedFileExtensions,
        type: "file",
        name: "document-upload-input",
      },
      on: { change: _vm.handleDocumentInputChange },
    }),
    _c("div", { staticClass: "document-upload-actions" }, [
      _c(
        "button",
        {
          staticClass: "btn mainBlue",
          attrs: { disabled: _vm.loading || _vm.disableActions },
          on: { click: _vm.handleUploadFileClick },
        },
        [
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [
              !_vm.loading
                ? _c("p", { staticClass: "text-medium" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "document.handleDocumentContainer.documentUploadStep.actions.primary"
                        )
                      )
                    ),
                  ])
                : _c("ma-spinner"),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }